export const getImagePreview = (blogPost: any) => {
  if (!blogPost.image) {
    return '/static/public/placeholder.png'
  }
  return `/static/blog/${blogPost.id}/images/${blogPost.image}`
}

